import { createContext } from "react";
import { TaxonomyAction } from "../actions/taxonomy";

export const TaxonomyDispatchContext = createContext<React.Dispatch<TaxonomyAction>>(() => { });